import axios from 'axios';

//const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7111/api';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ops-portal-api-dev.azurewebsites.net/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const extractLogsService = {
    // Get all runs
    getRuns: async (days = 7, facilityId = null) => {
        const params = { days };
        if (facilityId) params.facilityId = facilityId;
        const response = await api.get('/extractlogs/runs', { params });
        return response.data;
    },

    // Get run detail
    getRunDetail: async (runId) => {
        const response = await api.get(`/extractlogs/runs/${runId}`);
        return response.data;
    },

    // Get facilities list
    getFacilities: async () => {
        const response = await api.get('/extractlogs/facilities');
        return response.data;
    },

    // Get top license keys by duration
    getTopLicenseKeys: async (days = 7, facilityId = null, top = 10) => {
        const params = { days, top };
        if (facilityId) params.facilityId = facilityId;
        const response = await api.get('/extractlogs/top-license-keys', { params });
        return response.data;
    },

    // Get file type statistics
    getFileTypeStats: async (days = 7, facilityId = null) => {
        const params = { days };
        if (facilityId) params.facilityId = facilityId;
        const response = await api.get('/extractlogs/file-type-stats', { params });
        return response.data;
    },

    // Get file type statistics by facility (for stacked chart)
    getFileTypeStatsByFacility: async (days = 7) => {
        const params = { days };
        const response = await api.get('/extractlogs/file-type-stats-by-facility', { params });
        return response.data;
    },
};

export const diskSpaceService = {
    // Get disk space (uses cache)
    getDiskSpace: async () => {
        const response = await api.get('/diskspace');
        return response.data;
    },

    // Force refresh disk space
    refreshDiskSpace: async () => {
        const response = await api.get('/diskspace/refresh');
        return response.data;
    },

    // Get disk space for specific VM
    getDiskSpaceForVm: async (vmName) => {
        const response = await api.get(`/diskspace/${vmName}`);
        return response.data;
    },
};

export const jobsService = {
    // Get jobs (with optional filters)
    getJobs: async (hours = 24, status = null, jobType = null) => {
        const params = { hours };
        if (status) params.status = status;
        if (jobType) params.jobType = jobType;
        const response = await api.get('/jobs', { params });
        return response.data;
    },

    // Get active (running/queued) jobs
    getActiveJobs: async () => {
        const response = await api.get('/jobs/active');
        return response.data;
    },

    // Get job detail with logs
    getJobDetail: async (jobId) => {
        const response = await api.get(`/jobs/${jobId}`);
        return response.data;
    },
};

export const servicesService = {
    // Get all services
    getServices: async () => {
        const response = await api.get('/services');
        return response.data;
    },

    // Get specific service
    getService: async (name) => {
        const response = await api.get(`/services/${name}`);
        return response.data;
    },
};

export default api;
